<template>
    <div>
      <iframe
          ref="iframe"
          width="100%"
          height="400"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          :src="parsedUrl"
          v-if="parsedUrl">
      </iframe>
      <div>
          <v-input type="text" :name="name" :title="title" v-model="link" @input="input"></v-input>
          <span class="help-block"></span>
      </div>
  </div>
</template>

<script>
import urlParser from "js-video-url-parser";

export default {

  name: 'vVideo',
  props: {
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Vidéo (YouTube, Vimeo, Dailymotion)'
    },
    name: {
      type: String,
      default: 'videoLink'
    }
  },
  data () {
    return {
      link: this.value,
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.link = newVal
    }
  },
  methods: {
    input() {
      this.$emit('input', this.link)
    }
  },
  computed: {
    parsedUrl() {
      if (this.link === null | this.link ==='' ) return ''

      const createdUrl = urlParser.parse(this.link)

      return urlParser.create({
        videoInfo: createdUrl,
        format: 'embed'
      })
    }
  }
};
</script>

<style lang="css" scoped>
</style>
